import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tendering',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './tendering.component.html',
  styleUrl: './tendering.component.css',
})
export class TenderingComponent implements OnInit {
  isHovering1 = false;
  isHovering2 = false;
  isHovering3 = false;
  isHovering4 = false;
  isHovering5 = false;
  projectName: string;
  projectId: number;
  projectIdentifier: string;
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['name'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('projectId')
        ? parseInt(params.get('projectId'))
        : null;
    });
  }

  navigateToExpression() {
    this.router.navigate(['/eoi-submissions'], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  navigateToPQQ() {
    this.router.navigate(['/pqq-submissions'], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }
  navigateToRfp() {
    
    this.router.navigate([`${this.projectId}/tendering/rfp`], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  navigateToRfq() {
    this.router.navigate([`${this.projectId}/tendering/rfq`], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  goBack() {
    this.router.navigate(['/project-development', this.projectId], {
      queryParams: { name: this.projectName },
    });
  }
}
